import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

import { useHistory } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

import moment from 'moment';
import { CopyToClipboard } from "react-copy-to-clipboard";
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';


const Referral = props => {
  //meta title
  document.title = "Referral List";
  const history = useHistory();
  const { getRequest, postRequest } = useRequests();


  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};


  const [ReferralUsersTBody, setReferralUsersTBody] = React.useState('');
  const handleT1Body = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{moment(element.created_at).format('YYYY-MM-DD | HH:mm')}</td>
        <td>{element.first_name}</td>
        <td>{element.last_name}</td>
        <td>{element.email}</td>
      </tr>
    ));

    setReferralUsersTBody(tempTBody);
  }
  const handleLoadGetReferralUsers = async () => {
    const jsonpar = JSON.stringify({
      u_id: atob(props.match.params.id)
    });
    const res = await postRequest('get-referral-users', jsonpar);
    if (res && res.code === 200) {
      handleT1Body(res.data);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="5" className="text-center">No records found</td>
                      </tr>);

      setReferralUsersTBody(tempTBody);

      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  const [ UserInfo, setUserInfo ] = React.useState([]);
  const [ ReferralLink, setReferralLink ] = React.useState('');
  const handleLoadGetUserInfo = async () => {
    const jsonpar = JSON.stringify({
      u_id: atob(props.match.params.id)
    });
    const res = await postRequest('get-user-info', jsonpar);
    if (res && res.code === 200) {
      setUserInfo(res.data);
      setReferralLink(process.env.REACT_APP_SITE_URL+'register/'+res.data.referral_code);
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  React.useEffect(() => {
    if (!props.match.params.id) {
      history.push({
        pathname: '/user_management',
        state: { code: 401, status: 'error', message: 'ID not found! Please provide a valid ID.' }
      });
		}
    else {
      handleLoadGetUserInfo();
      handleLoadGetReferralUsers();
    }
  }, []);


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Eshepay")} breadcrumbItem={props.t("Referral List")} />
          <Row>
            <Col xs="12">
              <Row>
                <Col xl="12" md="12">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="mb-4 wordBreak">User Name : {UserInfo.first_name} {UserInfo.last_name} ( {UserInfo.email} )</h5>
                      <div className="mb-3 h4 card-title">Referral Link</div>
                      <div className="Referal">
                        <p>{ReferralLink}</p>
                        <CopyToClipboard text={ReferralLink}>
                          <i className="bx bx-copy-alt"></i>
                        </CopyToClipboard>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">

                    <div className="table-responsive mb-0" data-pattern="priority-columns">
                      <table className="table mb-0" style={{ minWidth: "1000px" }}>
                        <thead className="table-light">
                          <tr>
                            <th>ID</th>
                            <th>Date</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email ID</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ReferralUsersTBody}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

    </React.Fragment>
  );
};

export default withTranslation()(Referral);
